var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCppHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_cppheader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.395,25.5V6.5H4.727v6.817a5.212,5.212,0,0,1,4.121-1.892,5.558,5.558,0,0,1,2.657.6,3.539,3.539,0,0,1,1.614,1.665,7.677,7.677,0,0,1,.486,3.085V25.5H11.273V16.778a3.6,3.6,0,0,0-.758-2.547,2.819,2.819,0,0,0-2.145-.8,3.782,3.782,0,0,0-1.951.538,3.038,3.038,0,0,0-1.3,1.458,6.7,6.7,0,0,0-.389,2.54V25.5Z",
    style: {
      fill: "#984c93"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.727 14.829 16.727 12.485 19.071 12.485 19.071 14.829 21.415 14.829 21.415 17.172 19.071 17.172 19.071 19.515 16.727 19.515 16.727 17.172 14.385 17.172 14.385 14.828 16.727 14.829",
    style: {
      fill: "#984c93"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.928 14.829 24.928 12.485 27.272 12.485 27.272 14.829 29.615 14.829 29.615 17.172 27.272 17.172 27.272 19.515 24.928 19.515 24.928 17.172 22.585 17.172 22.585 14.828 24.928 14.829",
    style: {
      fill: "#984c93"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCppHeader);
export default __webpack_public_path__ + "static/media/cpp-header.33307ad77cb437b9fb3f717ceee8e7a3.svg";
export { ForwardRef as ReactComponent };